"use client";

import ToastContainerLazy from "@/contexts/ToastContainerLazy";
import { BlankContextProvider } from "@core/helpers/client/contexts/BlankContext";
import { InstallmentPaymentGatewaysContextProvider } from "@core/helpers/client/contexts/InstallmentPaymentGatewaysContext";
import { ProgressProvider } from "@bprogress/next/app";
import TracktorLoader from "@/components/TracktorLoader";

// provider منو را Layout هسته سوار می‌کند (`menu_keys` / `client_menu_keys` در app/layout.jsx)
const KernelContex = ({ children }) => {
  return (
    <>
      <TracktorLoader
        endpoint={"https://cdp.branchteam.ir"}
        pubKey={"pk299faa02e452b36f044086c1eb2908a2"}
      />
      <BlankContextProvider>
        <InstallmentPaymentGatewaysContextProvider>
          <ToastContainerLazy theme="light" />
          <ProgressProvider
            height="2px"
            color="#08535b"
            options={{ showSpinner: false }}
            shallowRouting
          />
          {children}
        </InstallmentPaymentGatewaysContextProvider>
      </BlankContextProvider>
    </>
  );
};

export default KernelContex;
